import React, { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';

// types
import { AttributeType } from 'types/create-campaign';

// components
import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { FilterRow } from '../FilterRow';

// store
import { useCreateNewAudienceActions } from 'store/CreateNewAudienceStore';

// styles
import './filterRowGroup.scss';

interface Props {
  attributesList: AttributeType[];
  filterGroup: any;
  setEstimatedBtnClicked: (clicked: boolean) => void;
}

export const FilterRowGroup: React.FC<Props> = (props) => {
  const filterIdFromCurrentArray = props.filterGroup?.[0].id;

  const { addFilterToGroup, setEstimatedAudience } =
    useCreateNewAudienceActions();

  const handleAddFilter = () => {
    props.setEstimatedBtnClicked(false);
    addFilterToGroup(filterIdFromCurrentArray);
    setEstimatedAudience({
      sms: null,
      push: null,
    });
  };

  const uuid = useMemo(() => uuidv4(), []);

  return (
    <div className='filter-group-wrapper'>
      <div className='filter-group'>
        {props.filterGroup?.map((item: any, index: number) => {
          return (
            <FilterRow
              key={uuid}
              itemId={item.id}
              attributesList={props.attributesList}
            />
          );
        })}
        <ButtonComponent
          label='+OR filter'
          onClick={handleAddFilter}
          size='middle'
          appereance='primary'
          fullWidth
        />
      </div>
    </div>
  );
};
